import ElProgress from './src/progress';

/* istanbul ignore next */
ElProgress.install = function(Vue) {
  Vue.component(ElProgress.name, ElProgress);
};

export default ElProgress;



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/packages/progress/index.js
// module id = 221
// module chunks = 0